import { PGA_COACH_SAVED_OFFERINGS_KEY } from './constants'

const readIds = () => {
  if (typeof window === 'undefined') return []
  try {
    const raw = window.localStorage.getItem(PGA_COACH_SAVED_OFFERINGS_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : []
  } catch {
    return []
  }
}

const writeIds = (ids) => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(PGA_COACH_SAVED_OFFERINGS_KEY, JSON.stringify([...new Set(ids)]))
}

export const getSavedOfferingIds = () => readIds()

export const isOfferingSaved = (offeringId) => {
  if (!offeringId) return false
  return readIds().includes(String(offeringId))
}

export const toggleSavedOffering = (offeringId) => {
  if (!offeringId) return false
  const id = String(offeringId)
  const next = readIds()
  const idx = next.indexOf(id)
  if (idx >= 0) {
    next.splice(idx, 1)
    writeIds(next)
    return false
  }
  next.push(id)
  writeIds(next)
  return true
}
